const ru = {
  code: 'ru',
  short: 'RU',
  label: 'Русский',
  native: 'Русский',
  hero: {
    badge: 'Клининг • Одесса',
    title: 'Жемчужина чистоты.',
    lead: 'Уборка квартир и помещений в Одессе.',
    whatsapp: 'WhatsApp'
  },
  header: {
    home: 'Главная',
    services: 'Услуги',
    contact: 'Контакты',
    whatsapp: 'WhatsApp',
    language: 'Язык'
  },
  home: {
    serviceNote: 'Pearl clean • Одесса • Чистота для вашего пространства',
    servicesTitle: 'Наши услуги',
    seeDetails: 'Подробнее →',
    whyTitle: 'Почему Pearl clean?',
    reasons: [
      'Услуги для квартир, офисов и коммерческих помещений',
      'Связь в WhatsApp круглосуточно',
      'График, состав работ и детали согласуются индивидуально',
      'Цены на основные виды уборки'
    ],
    areaTitle: 'Работаем',
    areaCopy: 'Одесса и ближайшие районы.',
    quote: 'Получить предложение'
  },
  optional: 'необязательно',
  servicesPage: {
    title: 'Услуги',
    subtitle: 'Нажмите на карточку, чтобы открыть список работ, галерею и примечания по цене.'
  },
  notFound: {
    message: 'Страница не найдена.',
    back: 'На главную'
  },
  serviceDetail: {
    notFound: 'Услуга не найдена',
    back: 'Назад к услугам',
    priceLabel: 'Стоимость',
    priceList: 'Прайс-лист',
    allServices: 'Все услуги'
  },
  contact: {
    title: 'Контакты',
    hours: 'Отвечаем круглосуточно.',
    phoneLabel: 'Телефон',
    locationLabel: 'Локация',
    whatsapp: 'Написать в WhatsApp',
    office: 'Одесса'
  },
  footer: {
    tagline: 'Клининговые услуги в Одессе для дома и бизнеса.',
    rights: 'Все права защищены.',
    getInTouch: 'Связаться',
    chat: 'Написать в WhatsApp'
  },
  whatsapp: {
    message: 'Здравствуйте! Хочу узнать больше об услугах Pearl clean в Одессе.'
  },
  services: [
    {
      slug: 'regular-cleaning',
      title: 'Базовая уборка',
      short: 'Основная уборка для поддержания чистоты в квартире или офисе.',
      intro: 'Базовая уборка помогает быстро привести пространство в аккуратное состояние.',
      description: [
        'Тщательно пылесосим и моем все доступные поверхности, аккуратно убираем пыль, чистим кухню и санузел — дом остаётся свежим и опрятным.',
        'Рекомендуемая частота: каждую неделю, раз в две недели или раз в месяц.'
      ],
      bullets: [
        'Пылесосим и моем полы',
        'Стираем пыль с доступных поверхностей',
        'Дезинфицируем кухню и ванную',
        'Выносим мусор и меняем пакеты'
      ],
      priceNote: 'от 60 грн/м²'
    },
    {
      slug: 'general-cleaning',
      title: 'Генеральная уборка',
      short: 'Баланс между регулярной и глубокой уборкой.',
      intro: 'Более детальная уборка, чем обычная поддержка.',
      description: [
        'Все шаги регулярной уборки плюс тщательная забота о кухне и ванной, внешние поверхности техники, внутренности духовки и холодильника, уход за зонами питомцев.',
        'Рекомендуемая частота: еженедельно, раз в две недели или раз в месяц.'
      ],
      bullets: [
        'Чек-лист регулярной уборки включен',
        'Детализация кухни и санузла',
        'Чистка духовки и холодильника внутри',
        'Удаление шерсти и уборка мест питомцев (кормление, лоток)'
      ],
      priceNote: 'от 85 грн/м²'
    },
    {
      slug: 'deep-cleaning',
      title: 'Глубокая уборка',
      short: 'Полное очищение сверху донизу для максимальной свежести.',
      intro: 'Самая детальная услуга с акцентом на труднодоступные зоны и технику.',
      description: [
        'Включает каждый шаг генеральной уборки, плюс окна изнутри и снаружи (где достаем), внутреннюю чистку шкафов и глубокую обработку техники: холодильник, духовка, микроволновка.',
        'По запросу — чистка мягкой мебели, ковров и балкона. Рекомендуем, когда нужно полностью освежить дом.'
      ],
      bullets: [
        'Удаление известкового налета и жира',
        'Чистка шкафов и гардеробов внутри',
        'Окна изнутри и снаружи (доступные)',
        'Глубокая чистка техники'
      ],
      priceNote: 'от 95 грн/м²'
    },
    {
      slug: 'upholstery-cleaning',
      title: 'Химчистка мебели',
      short: 'Профессиональная чистка мягкой мебели, матрасов и ковров.',
      intro: 'Возвращаем мебели и текстилю свежесть с расчётом по каждой позиции.',
      description: ['Выберите нужные позиции из прайс-листа.'],
      priceNote: 'Цены указаны за единицу, если не указано иное.',
      priceItems: [
        { id: 'two-seat-sofa', title: 'Диван 2-местный', price: 'от 1 000 грн' },
        { id: 'three-seat-sofa', title: 'Диван 3-местный', price: 'от 1 300 грн' },
        { id: 'large-straight-sofa', title: 'Большой прямой диван', price: 'от 1 500 грн' },
        { id: 'corner-sofa', title: 'Угловой диван', price: 'от 1 500 грн' },
        { id: 'large-corner-sofa', title: 'Большой угловой диван', price: 'от 1 800 грн' },
        { id: 'armchair', title: 'Кресло', price: 'от 400 грн' },
        { id: 'pouf', title: 'Пуф', price: 'от 250 грн' },
        { id: 'backless-chair', title: 'Стул без спинки', price: 'от 120 грн' },
        { id: 'chair-with-back', title: 'Стул со спинкой', price: 'от 180 грн' },
        { id: 'sofa-pillow', title: 'Диванная подушка', price: 'от 100 грн' },
        { id: 'single-mattress', title: 'Односпальный матрас', price: 'от 800 грн' },
        { id: 'double-mattress', title: 'Двуспальный матрас', price: 'от 1 100 грн' },
        { id: 'carpet', title: 'Ковёр / ковролин', price: 'от 70 грн/м²' }
      ]
    },
    {
      slug: 'post-construction-cleaning',
      title: 'Уборка после ремонта',
      short: 'Удаление пыли, краски и мусора после работ.',
      intro: 'Профессиональная уборка после ремонта или стройки.',
      description: [
        'Убираем пыль, клей, краску и мусор, моем окна, полы, поверхности и санузлы, чтобы помещение было готово к заселению — чистое и без пыли.'
      ],
      bullets: [
        'Удаление строительной пыли и остатков',
        'Детальная чистка фурнитуры, розеток и выключателей',
        'Мытьё окон, рам и подоконников',
        'Финальная полировка полов и поверхностей'
      ],
      priceNote: 'от ₴___'
    },
    {
      slug: 'move-in-move-out',
      title: 'Уборка при переезде',
      short: 'Идеально перед заселением или сдачей жилья.',
      intro: 'Детальная уборка для безупречной передачи или въезда.',
      description: [
        'Сосредотачиваемся на шкафах, технике, плинтусах и фурнитуре, чтобы квартира была безупречной для владельца или новых жильцов.',
        'Отлично подходит перед съемкой, проверками или заселением.'
      ],
      bullets: [
        'Шкафы и ящики очищены внутри',
        'Обезжиренная техника внутри',
        'Протёртые окна и рамы',
        'Внимание к деталям: плинтусы, выключатели'
      ],
      priceNote: 'от ₴___'
    },
    {
      slug: 'office-cleaning',
      title: 'Уборка офисов',
      short: 'Держите рабочее место безупречным и продуктивным.',
      intro: 'Безупречный и организованный офис с профессиональной командой.',
      description: [
        'Глубоко очищаем все зоны — от рабочих мест и переговорных до кухонь и санузлов — создаём чистую и гигиеничную среду.',
        'Команда работает точно и деликатно, поддерживает профессиональный имидж и комфортную атмосферу для сотрудников и клиентов.'
      ],
      bullets: [
        'Рабочие зоны, переговорные, ресепшен',
        'Дезинфекция кухонь и санузлов',
        'Вынос мусора и сортировка',
        'Гибкие графики вне рабочего времени'
      ],
      priceNote: 'от ₴___'
    },
    {
      slug: 'commercial-cleaning',
      title: 'Коммерческая уборка',
      short: 'Профессиональный сервис для ресторанов, отелей и магазинов.',
      intro: 'Создайте безупречную атмосферу для гостей и команды.',
      description: [
        'Предоставляем качественный клининг для ресторанов, отелей, магазинов, салонов, фитнес-центров и офисов, чтобы каждая зона была чистой и гигиеничной.',
        'Внимание к деталям — блестящие полы и мебель, продезинфицированные кухни и санузлы. Используем экологичные средства и проверенные методы для безопасности и комфорта.',
        'Гибкие графики и персональные планы под ваш режим работы для минимальных пауз.'
      ],
      bullets: [
        'Фронт, бэк-офис и складские зоны',
        'Дезинфекция зон частого касания',
        'Уход за твёрдыми полами и коврами',
        'Планы под каждый тип бизнеса'
      ],
      priceNote: 'от ₴___'
    },
    {
      slug: 'window-cleaning',
      title: 'Мойка окон',
      short: 'Кристально чистые окна внутри и снаружи.',
      intro: 'Прозрачные окна наполняют пространство светом.',
      description: [
        'Профессионально моем окна в квартирах, офисах и коммерческих помещениях — изнутри и снаружи (доступные зоны).',
        'Используем экологичные средства без разводов; стекло чистое, рамы блестят. Регулярная мойка улучшает освещение и внешний вид.'
      ],
      bullets: [
        'Внутренние и доступные внешние стёкла',
        'Протирка рам, подоконников и направляющих',
        'Экологичные средства без разводов',
        'Идеально для дома, офиса и витрин'
      ],
      priceNote: 'от ₴___'
    },
    {
      slug: 'carpet-upholstery-cleaning',
      title: 'Чистка ковров и мебели',
      short: 'Глубокая очистка ковров и мягкой мебели.',
      intro: 'Возвращаем мягкость и устраняем запахи.',
      description: [
        'Удаляем пятна, аллергены и налёт профессиональной техникой под тип ткани, текстиль снова свежий.',
        'Идеально как дополнение к глубокой уборке или самостоятельное обновление для загруженных зон.'
      ],
      bullets: [
        'Экстракция горячей водой или маловлажные методы',
        'Точечное удаление пятен и запахов',
        'Щадящие решения для деликатных тканей',
        'Быстрое высыхание для минимальных простоев'
      ],
      priceNote: 'от ₴___'
    }
  ]
};

export default ru;
